import { getKeyWords } from '@/services/api'
export default {
  namespace: 'dictionaries',
  state: {
    temiBuild: [],
    temiRoom: [],
    temiLanguage: [],
  },
  effects: {
    *getBuild({ payload = 'TEMI_BUILDING_LABEL' }, { call, put }) {
      const res = yield call(getKeyWords, payload)
      yield put({
        type: 'temiBuild',
        payload: res,
      })
    },
    *getRoom({ payload = 'TEMI_ROOM_TYPE' }, { call, put }) {
      const res = yield call(getKeyWords, payload)
      yield put({
        type: 'temiRoom',
        payload: res,
      })
    },
    *getLanguage({ payload = 'TEMI_BUILDING_LANGUAGE' }, { call, put }) {
      const res = yield call(getKeyWords, payload)
      yield put({
        type: 'temiLanguage',
        payload: res,
      })
    },
  },
  reducers: {
    temiBuild(state, { payload }) {
      return {
        ...state,
        temiBuild: payload,
      }
    },
    temiRoom(state, { payload }) {
      return {
        ...state,
        temiRoom: payload,
      }
    },
    temiLanguage(state, { payload }) {
      return {
        ...state,
        temiLanguage: payload,
      }
    },
  },
}
